import { LatLng, distanceTo } from "geolocation-utils";

import { api } from "api";
import { IBestBikingRoad, Iterable } from "types";

export class BestBikingRoad {
  private road: Iterable<IBestBikingRoad>;

  constructor(_road: Iterable<IBestBikingRoad>) {
    this.road = _road;
  }

  // Getters

  public get instance() {
    return this.road;
  }

  public get rating() {
    return this.road.rating;
  }

  public get id() {
    return this.road.id;
  }

  public get coordinates() {
    return this.road.geometry.coordinates;
  }

  // Public Methods

  public getDirection(toPoint: LatLng) {
    const [start, finish] = [
      this.coordinates[0],
      this.coordinates[this.coordinates.length - 1],
    ];

    const distanceFromStart = distanceTo(start, toPoint);
    const distanceFromFinish = distanceTo(finish, toPoint);

    if (distanceFromStart > distanceFromFinish) {
      return [...this.coordinates].reverse();
    }

    return this.coordinates;
  }

  public findClosestPointsOn(coordinates: LatLng[]) {
    const roadCoords = this.getDirection(coordinates[0]);
    const [start, finish] = [roadCoords[0], roadCoords[roadCoords.length - 1]];

    // console.log({ start, finish });

    const distancesToStart = coordinates.map((c) => distanceTo(start, c));
    const minDistanceToStart = Math.min(...distancesToStart);
    const startIndex = distancesToStart.indexOf(minDistanceToStart);

    const fromStartSlice = coordinates.slice(
      startIndex,
      coordinates.length - 1
    );
    const distancesToFinish = fromStartSlice.map((c) => distanceTo(finish, c));
    const minDistanceToFinish = Math.min(...distancesToFinish);
    const finishIndex = distancesToFinish.indexOf(minDistanceToFinish);

    const oldFinishIndex = finishIndex + startIndex;

    // const startCoordinate = coordinates[startIndex];
    // const finishCoordinate = coordinates[oldFinishIndex];
    // console.log({ startCoordinate, finishCoordinate });

    return {
      indexes: [startIndex, oldFinishIndex],
      distances: [minDistanceToStart, minDistanceToFinish],
    };
  }
}

export class BestBikingRoads {
  private _countries: string[];
  private _all: BestBikingRoad[] = [];

  constructor(inCountries: string[]) {
    this._countries = inCountries;
  }

  // Getters

  public get all() {
    return this._all;
  }

  // Public Methods

  public async fetch() {
    try {
      const codes = this._countries;
      const response = await api.firestore.bestBikingRoads.list(codes);
      const bestBikingRoads = response.map((item) => new BestBikingRoad(item));
      this._all = bestBikingRoads;
      return Promise.resolve(bestBikingRoads);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  filterDisabled() {
    const filtered = this.all.filter((item) => !item.instance.disabled);
    this._all = filtered;
  }
}
